export const selectTasks = state => state.tasks;
